import type React from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import type { Movement as PetitionMovement } from '#src/app/pages/petitionDetails/shared/types';

import { MovementCard } from './components/MovementCard';

type Props = {
	movement: PetitionMovement;
	alwaysExpanded?: boolean;
};

export const Movement: React.FC<Props> = (props) => {
	const {
		data: {
			petition: { id: petitionId },
		},
	} = usePetitionDetailsPageData();
	return <MovementCard petitionId={petitionId} {...props} />;
};
